module.exports = __webpack_public_path__ + "static/media/linkedin-icon.7f284d51.svg";